import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postResultDenomination = (params) => {
    return axios.post(`${backendHost}/api/admin/freespin/bets`, params);
};

export {
    postResultDenomination
}